import { WorkflowType } from '@kindo/universal';
import { useState } from 'react';

import WorkflowBuilderConfigurationEditor from '../../WorkflowBuilder/WorkflowBuilderConfiguration/WorkflowBuilderConfigurationEditor';
import WorkflowViewLayout from '../shared/WorkflowViewLayout/WorkflowViewLayout';

import { FileResource } from '~/components/Chat/AddFileModal';
import { Button, ButtonType } from '~/components/core';

interface WorkflowChatbotToolboxProps {
  onCreateWorkflow: (params: {
    knowledgeStoreContent: FileResource[];
    systemPrompt: string;
  }) => void;
}

const WorkflowChatbotToolbox: React.FC<WorkflowChatbotToolboxProps> = ({
  onCreateWorkflow
}) => {
  const [systemPrompt, setSystemPrompt] = useState('');
  const [knowledgeStoreContent, setKnowledgeStoreContent] = useState<
    FileResource[]
  >([]);

  const handleCreate = () => {
    onCreateWorkflow({
      systemPrompt,
      knowledgeStoreContent
    });
  };

  const isValid = !!systemPrompt.trim() || knowledgeStoreContent.length > 0;

  return (
    <WorkflowViewLayout workflowType={WorkflowType.CHATBOT}>
      <div
        className="bg-blue-chat-background flex flex-col gap-8 rounded-lg border border-white/10 p-6"
        data-testid="chatbot-section-container"
      >
        <WorkflowBuilderConfigurationEditor
          knowledgeStoreContent={knowledgeStoreContent}
          onKnowledgeStoreContentChange={setKnowledgeStoreContent}
          onSystemPromptChange={setSystemPrompt}
          systemPrompt={systemPrompt}
        />
        <div
          className="flex justify-end"
          data-testid="create-chatbot-button-container"
        >
          <Button
            disabled={!isValid}
            label="Create Agent"
            onClick={handleCreate}
            type={ButtonType.SOLID_COLOR}
          />
        </div>
      </div>
    </WorkflowViewLayout>
  );
};

export default WorkflowChatbotToolbox;
